// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import { BiomarkerResultsContext } from './BiomarkerResults.helpers';
export function useBiomarkerResultsContext() {
    return React.useContext(BiomarkerResultsContext);
}
